import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';

import { RootState } from '../store';
import { updateSiteConstant } from '../store/reducer';

import { getValueFromLocalStorage } from '../utils/common';
import { routesToAllowedForAIBot } from '../utils/contant';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { Loader } from '../ui-component';

import { ContentContainer, PrivateContainer, RightContainer } from './style';
import { useFetchSiteConstant } from './hook/useFetchSiteConstants';

type PrivateWrapperProps = {
  Content: () => JSX.Element | null;
  sidebarRequired?: boolean;
};

const PrivateWrapper = ({ Content, sidebarRequired = true }: PrivateWrapperProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = getValueFromLocalStorage('token');

  const { commonDataReducer } = useSelector((state: RootState) => state);
  const { currLang } = commonDataReducer;

  const pathName = window.location.pathname.split('/')[1];
  const currentLanguageObj = currLang ?? getValueFromLocalStorage('currLang');

  const currentLanguage =
    !_isNil(currentLanguageObj) && !_isEmpty(currentLanguageObj) ? currentLanguageObj.value : 'en';

  const { handleGetSiteConstantsApi, isLoading } = useFetchSiteConstant();

  useEffect(() => {
    if (_isNil(token) || token === '') {
      navigate('/login');
    }
  }, [token]);

  useEffect(() => {
    void updateBotElement();
    // void handleGetSiteConstantsApi(currentLanguage);
  }, [pathName]);

  useEffect(() => {
    dispatch(updateSiteConstant({ data: {} }));
    void handleGetSiteConstantsApi(currentLanguage);
  }, [currentLanguage]);

  const updateBotElement = () => {
    const buildEnv = process.env.REACT_APP_BUILD_ENVIRONMENT;
    const botElement = document.getElementById('wonderchat-wrapper');

    if (buildEnv === 'production' && !_isNil(botElement)) {
      if (routesToAllowedForAIBot.includes(pathName)) {
        botElement.style.display = 'block';
      } else {
        botElement.style.display = 'none';
      }
    }
  };

  return (
    <>
      <PrivateContainer sidebarRequired={sidebarRequired}>
        {!isLoading && (
          <>
            <Sidebar />

            <RightContainer>
              <Header />
              <ContentContainer>
                <Content />
              </ContentContainer>
            </RightContainer>
          </>
        )}
        <Loader showLoader={isLoading} />

        {/* {sidebarRequired ? (
          <>
            <Sidebar />
            <RightContainer>
              <Header />
              <ContentContainer>
                <Content />
              </ContentContainer>
            </RightContainer>
          </>
        ) : (
          <>
            <PublicHeader />
            <ContentContainer hasHeader={true}>
              <Content />
            </ContentContainer>
          </>
        )} */}
      </PrivateContainer>
    </>
  );
};

export default PrivateWrapper;
